const _ = require("lodash");

const words = {
	0: "zero",
	1: "one",
	2: "two",
	3: "three",
	4: "four",
	5: "five",
	6: "six",
	7: "seven",
	8: "eight",
	9: "nine",
	10: "ten",
	11: "eleven",
	12: "twelve",
	13: "thirteen",
	14: "fourteen",
	15: "fifteen",
	16: "sixteen",
	17: "seventeen",
	18: "eighteen",
	19: "nineteen",
	20: "twenty",
	30: "thirty",
	40: "forty",
	50: "fifty",
	60: "sixty",
	70: "seventy",
	80: "eighty",
	90: "ninety",
};

const ordinals = {
	1: "first",
	2: "second",
	3: "third",
	4: "fourth",
	5: "fifth",
	6: "sixth",
	7: "seventh",
	8: "eighth",
	9: "ninth",
	10: "tenth",
	11: "eleventh",
	12: "twelfth",
	13: "thirteenth",
	14: "fourteenth",
	15: "fifteenth",
	16: "sixteenth",
	17: "seventeenth",
	18: "eighteenth",
	19: "nineteenth",
	20: "twentieth",
};

const unitWords = {
	cm: "centimeter",
	units: "unit",
	ft: "feet",
	mi: "mile",
	in: "inch",
	yd: "yard",
	m: "meter",
	km: "kilometer",
};

const toWord = function(x) {
	if (isNaN(x)) return "[gen_error]";

	if (x <= 20) return words[x];
	if (x < 100 && x % 10 === 0) return words[x];
	if (x > 100) return "" + x;

	return toWord(x - (x % 10)) + "-" + toWord(x % 10);
};

const toTimesWord = function(x) {
	if (x === 2) return "twice";

	return toWord(x) + " times";
};

const toOrdinal = function(x) {
	if (isNaN(x)) return "[gen_error]";

	if (x > 20) {
		return "[gen_error]";
	}

	return ordinals[x];
};

const toOrdinalSuffix = function(digit, raiseText) {
	digit = digit % 10;

	let suffix = "th";
	if (digit === 1) {
		suffix = "st";
	} else if (digit === 2) {
		suffix = "nd";
	} else if (digit === 3) {
		suffix = "rd";
	}

	return raiseText ? `^{\\text{${suffix}}}` : suffix;
};

const toPossessive = function(x) {
	if (x.substring(x.length - 1, x.length) === "s") return x + "'";

	return x + "'s";
};

const toFractionWord = function(x) {
	if (x === 2) return "half";

	return toOrdinal(x);
};

const overridePlural = {
	popcorn: "popcorn",
	is: "are",
	has: "have",
	it: "they",
	feet: "feet",
	this: "these",
};

const pluralizeSingle = function(x, number) {
	if (_.isString(number)) number = parseInt(number, 10);

	if (number === 1) return x;
	if (overridePlural[x]) return overridePlural[x];
	if (x.length > 1 && x.substring(x.length - 2) === "ch") return x + "es";
	if (x.length > 1 && x.substring(x.length - 1) === "s") return x + "es";

	return x + "s";
};

const pluralize = function(str, number) {
	let arr;

	if (Array.isArray(str)) arr = str;
	else arr = str.split(" ");

	const plurals = _.map(arr, x => pluralizeSingle(x, number));

	return plurals.join(" ");
};

const toUnitWord = function(unit, number) {
	const unitWord = unitWords[unit];

	return pluralize(unitWord, number);
};

const regPolys = {
	3: "equilateral triangle",
	4: "square",
	5: "regular pentagon",
	6: "regular hexagon",
	7: "regular heptagon",
	8: "regular octagon",
	9: "regular nonagon",
	10: "regular decagon",
};

const regularPolygon = function(x) {
	return regPolys[x];
};

const polys = {
	3: "triangle",
	4: "square",
	5: "pentagon",
	6: "hexagon",
	7: "heptagon",
	8: "octagon",
	9: "nonagon",
	10: "decagon",
};

const placeWords = {
	10: "tens",
	100: "hundreds",
	1000: "thousands",
};

const toPlaceWord = function(x) {
	return placeWords[x];
};

const capitalize = function(x, ignore) {
	if (ignore) return x;
	return x.charAt(0).toUpperCase() + x.slice(1);
};

const capitalizeAll = function(x) {
	return x
		.split(" ")
		.map(y => capitalize(y))
		.join(" ");
};

const article = function(word, articleOnly) {
	if (Array.isArray(word)) return word.map(x => article(x));
	const firstChar = word.length > 0 ? word.charAt(0) : "";

	let art = "a";

	if (_.includes(["a", "e", "i", "o", "u", "8"], firstChar)) {
		art = "an";
	}

	return articleOnly ? art : art + " " + word;
};

const writeList = function(elems, forceComma, mathEnclose) {
	const lastComma = forceComma ? "," : "";
	elems = [].concat(elems);
	if (mathEnclose) elems = _.map(elems, x => "$" + x + "$");
	if (elems.length === 1) return elems[0] + "";
	const last = elems.splice(elems.length - 1, 1)[0];
	return elems.join(", ") + lastComma + " and " + last;
};

// text for 4 depends on context
const toPolygonWord = function(x) {
	return polys[x];
};

module.exports = {
	toWord,
	toOrdinal,
	toOrdinalSuffix,
	toFractionWord,
	pluralize,
	pluralizeSingle,
	toUnitWord,
	regularPolygon,
	toPolygonWord,
	article,
	capitalize,
	capitalizeAll,
	writeList,

	toTimesWord,
	toPossessive,
	toPlaceWord,
};
